import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAReportFrequency() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ reportFrequency, setReportFrequency ] = useState(powerOfAttorney.report_frequency || 'quarterly');
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../report-recipients');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      report_frequency: reportFrequency
    }));
    navigate('../reports-complete');
  }, [ reportFrequency, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-report-frequency screen-container screen">
      <ScreenHeader
        title="Report Frequency"
        description="Choose how often your agent should provide reports"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>How Often Should Reports Be Sent?</h3>
        <p>
          Choose the frequency for period reports from your agent. Consider 
          the complexity of your finances and the preferences of report recipients.
        </p>

        <div className="frequency-options">
          <div className="frequency-option">
            <label className="frequency-label">
              <input
                type="radio"
                name="report-frequency"
                value="quarterly"
                checked={reportFrequency === 'quarterly'}
                onChange={(e) => setReportFrequency(e.target.value)}
              />
              <div className="frequency-content">
                <h4>Quarterly (Every 3 Months)</h4>
                <p>Reports sent four times per year</p>
                <div className="frequency-details">
                  <span>More frequent oversight</span>
                  <span>Earlier detection of issues</span>
                  <span>More work for agent</span>
                </div>
              </div>
            </label>
          </div>

          <div className="frequency-option">
            <label className="frequency-label">
              <input
                type="radio"
                name="report-frequency"
                value="semi-annually"
                checked={reportFrequency === 'semi-annually'}
                onChange={(e) => setReportFrequency(e.target.value)}
              />
              <div className="frequency-content">
                <h4>Semi-Annually (Every 6 Months)</h4>
                <p>Reports sent twice per year</p>
                <div className="frequency-details">
                  <span>Balanced approach</span>
                  <span>Reasonable oversight</span>
                  <span>Less burden on agent</span>
                </div>
              </div>
            </label>
          </div>
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            The first report should be sent within the chosen time period after 
            your agent begins acting. Reports should include activities since the 
            last report or since the agent began acting.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
